<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Halftitle Page">
<p class="title_hf"><span epub:type="pagebreak" id="page_1" title="1"><img alt="" src="images/half.jpg" style="height: 100%;"/></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle01.vue?4db2d599